import { css } from "lit";
import { constants as coreConstants } from "@omegagrid/core";
import constants from "../../constants";

export const itemStyle = css`
	.item {
		padding-bottom: ${constants.FILTER_PADDING / 2}px;
		padding-top: ${constants.FILTER_PADDING / 2}px;
	}

	.item:first-child {
		padding-top: 0;
	}

	.item-inner {
		border: 1px solid var(--og-colortype-accent-border-color);
		background-color: var(--og-accent-color-alpha-30);
		border-radius: var(--og-base-radius);
		color: var(--og-text-color-3);
		height: ${coreConstants.LIST_ITEM_HEIGHT}px;
		padding-left: 5px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.item-inner > * {
		flex: 1;
	}

	.item-inner > og-button, .item-inner > og-dropdown {
		flex: 0 0 ${coreConstants.LIST_ITEM_HEIGHT - 2}px;
		height: ${coreConstants.LIST_ITEM_HEIGHT - 2}px;
	}

	.item.empty-drop {
		height: ${coreConstants.LIST_ITEM_HEIGHT}px;
		background: repeating-linear-gradient(45deg, var(--og-accent-color-alpha) 0, var(--og-accent-color-alpha) 2px, transparent 0, transparent 50%);
		background-size: 10px 10px;
    	background-color: transparent;
	}

	.item.empty-drop:hover {
		border-top: 2px solid var(--og-accent-color);
		border-bottom: 2px solid var(--og-accent-color);
	}
`;

export const style = css`
	:host {
		padding: 0 10px 0 0;
	}
	
	og-dropdown-menu, og-button.add {
		width: 100%;
		border: 1px dashed var(--og-accent-color);
	}

	.axis {
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid var(--og-border-color);
	}

	.axis:last-of-type {
		border-bottom: none;
	}

	.axis-header {
		flex: 0 0 ${coreConstants.LIST_ITEM_HEIGHT}px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid var(--og-border-color);
		position: relative;
	}

	.axis-header .btn-switch-axes {
		position: absolute;
		bottom: -8px;
		z-index: 100;
		font-size: 8px;
		height: 16px;
	}

	.axis-body {
		flex: 1;
		padding: ${constants.FILTER_PADDING}px;
	}

	.row {
		margin: 0;
	}

	.row-buttons {
		display: flex;
		align-items: center;
		flex-direction: row;
		gap: ${constants.FILTER_PADDING}px;
	}

	og-button.total {
		border: 1px solid var(--og-accent-color);
	}
`;
